import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { CdekLocation } from './CdekLocation'
/**
* Class UpdateOrderDeliveryCdekCourier
*  Доставка CDEK курьером: город СДЭК и адрес до двери, без ПВЗ.
*/
export class UpdateOrderDeliveryCdekCourier extends ActiveModel {

  /**
  * kind
  *   */
  @ActiveField({ readonly: true, value: () => 'CdekCourier' })
  readonly kind: string = 'CdekCourier'


  /**
  * deliveryMethodId
  * Идентификатор способа из каталога канала.  */
  @ActiveField(0)
  deliveryMethodId: number = 0


  /**
  * deliverTo
  * Адрес назначения (без Domain.Entities.Cdek.CdekLocation.OfficeCode).  */
  @ActiveField({
    factory: [CdekLocation, () => undefined]
  })
  deliverTo?: CdekLocation


/**
  * slotDate
  * Дата выбранного окна доставки (обязательна, если estimated-intervals вернул окна).
  */
  @ActiveField()
  slotDate?: null | string


/**
  * slotTimeFrom
  * Начало окна (`HH:mm`).
  */
  @ActiveField()
  slotTimeFrom?: null | string


/**
  * slotTimeTo
  * Конец окна (`HH:mm`).
  */
  @ActiveField()
  slotTimeTo?: null | string
}
